export const displayDownloadData  = process.env.REACT_APP_DISPLAY_DOWNLOAD_DATA === "true"

export const displayMorseFeature        = process.env.REACT_APP_DISPLAY_MORSE         === "true"
export const displayBradenFeature       = process.env.REACT_APP_DISPLAY_BRADEN        === "true"
export const displayBradenQFeature      = process.env.REACT_APP_DISPLAY_BRADEN_Q      === "true"
export const displayJohnsHopkinsFeature = process.env.REACT_APP_DISPLAY_JOHNS_HOPKINS === "true"
export const displayMedicinesFeature    = process.env.REACT_APP_DISPLAY_MEDICINES     === "true"
